<template>
  <div v-if="active" ref="glow" class="cursor-glow" aria-hidden="true" />
</template>

<script>
import gsap from 'gsap'
import { prefersReducedMotion } from '@/composables/useReducedMotion'

export default {
  name: 'CursorGlow',
  data () {
    return {
      active: false
    }
  },
  mounted () {
    const isTouch = window.matchMedia('(pointer: coarse)').matches
    if (isTouch || prefersReducedMotion()) return

    this.active = true
    this.$nextTick(() => {
      this.moveX = gsap.quickTo(this.$refs.glow, 'x', { duration: 0.5, ease: 'power3.out' })
      this.moveY = gsap.quickTo(this.$refs.glow, 'y', { duration: 0.5, ease: 'power3.out' })
      window.addEventListener('pointermove', this.handleMove)
      window.addEventListener('pointerdown', this.handleDown)
      window.addEventListener('pointerup', this.handleUp)
    })
  },
  beforeUnmount () {
    window.removeEventListener('pointermove', this.handleMove)
    window.removeEventListener('pointerdown', this.handleDown)
    window.removeEventListener('pointerup', this.handleUp)
  },
  methods: {
    handleMove (e) {
      this.moveX(e.clientX)
      this.moveY(e.clientY)
    },
    handleDown () {
      gsap.to(this.$refs.glow, { scale: 0.7, duration: 0.2, ease: 'power2.out' })
    },
    handleUp () {
      gsap.to(this.$refs.glow, { scale: 1, duration: 0.3, ease: 'power2.out' })
    }
  }
}
</script>

<style scoped>
.cursor-glow {
  position: fixed;
  top: -120px;
  left: -120px;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  background: radial-gradient(circle, rgba(63, 185, 80, 0.10) 0%, rgba(88, 166, 255, 0.06) 45%, transparent 70%);
  mix-blend-mode: screen;
  will-change: transform;
}

@media (hover: none) {
  .cursor-glow {
    display: none;
  }
}
</style>
